<template>
  <div class="teacherdetail">
    <div class="block">
      <Info />
      <div
        @click="() => (this.action = this.action == 1 ? 0 : 1)"
        class="intro"
        :class="{ 'van-multi-ellipsis--l3': action == 1 }"
      >
        这里是讲师的简介，最多显示三行多余的需这里是讲师的简介，最多显示三行多余的需这里是讲师的简介，最多显示三行多余的需要隐藏，可以点击展开收缩，若没有填写简介不显示，讲师简介，最多显示三行多余的需要隐藏，可以点击展开收缩，若没有填写简介不需
      </div>
    </div>
    <div class="list">
      <div class="title">讲师课程</div>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-for="item in list" :key="item" class=" ">
           <Course/>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import Info from "./compontents/info";
import Course from './compontents/course'
export default {
  components: {
    Info,
    Course
  },
  data() {
    return {
      action: 1,
      list: [],
      loading: false,
      finished: false,
      info:''
    };
  },

  methods: {
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 1000);
    },
    getinfo() {
      userinfo().then((res) => {
        this.info = res;
      });
    },
  },
  mounted(){
    this.getinfo()
  }
};
</script>
<style lang="less" scoped>
.teacherdetail {
  width: 100%;
  .block {
    width: 375px;
    // min-height: 145px;
    height: auto;
    line-height: 20px;
    background-color: rgba(255, 255, 255, 100);
    color: rgba(16, 16, 16, 100);
    font-size: 14px;
    text-align: center;
    font-family: -apple-system;
    border: 1px solid rgba(255, 255, 255, 100);
    padding: 16px 20px 15px;
    .intro {
      width: 335px;
      // height: 51px;
      color: rgba(153, 153, 153, 100);
      font-size: 12px;
      text-align: left;
      line-height: 17px;
      font-family: PingFangSC-regular;
      margin-top: 15px;
      box-sizing: content-box;
    }
  }
  .list {
    padding: 15px 20px;
    .title {
      color: rgba(48, 91, 119, 100);
      font-size: 16px;
      text-align: left;
      font-family: PingFangSC-regular;
    }

  }
}
</style>